import {Button, ButtonState} from '@fantasmagames/core/src/display/Button';
import {SpineAnimation} from '@fantasmagames/core/src/display/SpineAnimation';
import {Spine} from '@fantasmagames/core/src/spine/Spine';
import {UpdateManager} from '@fantasmagames/core/src/update/UpdateManager';

/**
 * Animation names.
 */
interface StateMap {
	[state: number]: string;
}
interface LoopStateMap {
	[state: number]: boolean;
}

export class SpineButton extends Button {
	protected _spineAnimation: SpineAnimation;
	protected _spine: Spine;
	protected _animation: StateMap = {};
	protected _animationLoop: LoopStateMap = {};
	protected _updateManager: UpdateManager;
	protected _skin: string = '';

	protected _onClickIsOverState: boolean = true;

	constructor(callback?: Function) {
		super(callback);
	}

	public remove(): void {
		this._spineAnimation.stop();
		this._spine.destroy();
		this.destroy();
	}

	public setOnClickIsOverState(clickIsOverState: boolean): void {
		this._onClickIsOverState = clickIsOverState;
	}

	public setupButton(spine: Spine, updateManager: UpdateManager, skin?: string): void {
		this._updateManager = updateManager;
		this._spine = spine;
		this.addChild(this._spine);
		this._skin = skin;
		this._spineAnimation = new SpineAnimation(spine, 'IDLE', true, true);
		this.setSkinOnAnimation();
		this._spineAnimation.start();
		this._updateManager.add(this._spineAnimation);
	}

	public setAnimations(up: string, down?: string, over?: string, disabled?: string): void {
		this._animation[ButtonState.UP] = up;
		this._animation[ButtonState.DOWN] = down ? down : up;
		this._animation[ButtonState.OVER] = over ? over : up;
		this._animation[ButtonState.DISABLED] = disabled ? disabled : up;
	}

	public setAnimationsLoop(up: boolean, down?: boolean, over?: boolean, disabled?: boolean): void {
		this._animationLoop[ButtonState.UP] = up;
		this._animationLoop[ButtonState.DOWN] = this.isUndefined(down) ? up : down;
		this._animationLoop[ButtonState.OVER] = this.isUndefined(over) ? up : over;
		this._animationLoop[ButtonState.DISABLED] = this.isUndefined(disabled) ? up : disabled;
	}

	protected onClick(): void {
		if (this._onClickIsOverState) {
			super.onClick();
		} else {
			if (this._callback) {
				this._callback();
			} else {
				console.warn('There is no a callback.');
			}
		}
	}

	protected cleanFrame(): void {
		if (this._spineAnimation && this._spineAnimation.isPlaying) {
			this._spineAnimation.stop();
		}
	}

	protected updateFrame(): void {
		if (this._animation[this._state]) {
			this.cleanFrame();
			this._spineAnimation = new SpineAnimation(this._spine, this._animation[this._state], this._animationLoop[this._state], true);
			this.setSkinOnAnimation();
			this._updateManager.add(this._spineAnimation);
			this._spineAnimation.start();
		}
	}

	protected setSkinOnAnimation(): void {
		if (this._skin && this._skin.length > 0) {
			(this._spineAnimation.container as Spine).skeleton.setSkin(null);
			(this._spineAnimation.container as Spine).skeleton.setSkinByName(this._skin);
		}
	}

	private isUndefined(value: any): boolean {
		return typeof value === 'undefined';
	}

	public get container(): Spine {
		return this._spine;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/display/SpineButton.ts